import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { Form } from 'antd'
import { IoAddCircleOutline } from "react-icons/io5"
import moment from 'moment'
import { useOutletContext } from 'react-router-dom'

import useCommonAPI from 'Shared/API/Common'

import useFetchData from 'Shared/Hooks/useFetchData'
import PopupModal from 'Shared/Components/PopupModal'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import { DatePicker, Dropdown, TextInput, FormContainer } from 'Shared/Components/FormComponents'
import { showSuccess } from 'Shared/Components/NotifyToast'

const VRTrainingRecord = () => {
  const { role, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()
  const [form] = Form.useForm()

  const [traingRecord, setTraingRecord] = useState([])
  const [workers, setWorkers] = useState([])
  const [formOpen, setFormOpen] = useState(false)

  const tableRef = useRef()

  const { getWorkers } = useCommonAPI()

  const getTrainingRecord = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/vr_training/list`,
      params: {
        "offset": (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
        "limit": tableRef.current.getState()["itemsPerPage"]
      },
      returnType: "json"
    })

    body && setTraingRecord({
      "data": body["data"],
      "count": Math.ceil(body["count"]/tableRef.current.getState()["itemsPerPage"])
    })
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        getTrainingRecord()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  const loadData = async () => {
    tableRef.current.setTableLoading(true)

    await getTrainingRecord(false)

    tableRef.current.setTableLoading(false)
  }

  const toggleForm = async () => {
    if (!formOpen) {
      setPageLoading (true)

      const w = await getWorkers()
      setWorkers(w["data"])

      await getWorkers()

      setPageLoading (false)
    }
    else{
      form.resetFields()
      
    }
    
    setFormOpen(!formOpen)
  }

  const onFinish = async (values) => {
    setPageLoading(true)

    const res = await send({
      method: "POST",
      url: `${apiUrl}/vr_training/record`,
      contentType: "json",
      body: {
        "worker_id": values["worker_id"],
        "training_module": values["training_module"],
        "training_date": moment(new Date(values["training_date"])).unix(),
      }
    })

    if (res != null) {
      toggleForm()
      showSuccess(t("general_success"))

      tableRef.current.setTableLoading(true)

      await getTrainingRecord()

      tableRef.current.setTableLoading(false)
    }

    setPageLoading(false)
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={traingRecord["data"]} count={traingRecord["count"]} loadData={() => loadData()} ref={tableRef}
              columns={{
                "training_date": { "label": t("vrTraining_trainingDate"), "sorting": false, "nowrap": true },
                "worker_name": { "label": t("general_workerName"), "sorting": false, "nowrap": true },
                "training_module": { "label": t("vrTraining_trainingModule"), "sorting": false, "nowrap": true },
              }}
              appActions={() => { return [
                (["pm", "so", "admin"].includes(role)) && {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { toggleForm() }}
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 

    <PopupModal isOpen={formOpen} close toggle={() => toggleForm()} width="80%">
      <FormContainer form={form} onFinish={onFinish} initialValues={{}}>
        <Dropdown field_name={t("general_workerName")} field_id="worker_id" required props={{ "options": workers.map((i) => ({ "value": i["worker_id"], "label": i["worker_name"] })) }}/>
        <DatePicker field_name={t("vrTraining_trainingDate")} field_id="training_date" required props={{ "type": "date", "max":  new Date() }} />
        <TextInput field_name={t("vrTraining_trainingModule")} field_id="training_module" required />
      </FormContainer>
    </PopupModal>
  </>)
}

export default VRTrainingRecord
